import { useMutation, useQueryClient } from '@tanstack/react-query';
import { provisionAndGrantAdmin } from '../services/admins';
import { adminQueryKeys } from './query-keys';

export const useGrantAdminMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const result = await provisionAndGrantAdmin(payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to add admin user');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: adminQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
